import { HttpErrorResponse } from '@angular/common/http';
import { IFinalGradeCertificate } from 'app/library/certificate/services/certificate.api-service';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { FinalGradeExtended } from '../models/final-grade-extended.model';
import { FinalGradeCommand } from '../models/final-grade.command.model';
import { FinalGrade } from '../models/final-grade.model';

export class SetFinalGrade {
    static readonly type = '[FinalGrade] SetFinalGrade';

    constructor(public payload: FinalGrade) {}
}

export class UnsetFinalGrade {
    static readonly type = '[FinalGrade] UnsetFinalGrade';
}

export class FetchParticipantFinalGrade {
    static readonly type = '[FinalGrade] FetchParticipantFinalGrade';

    constructor(public payload: string) {}
}

export class FetchFinalGrade {
    static readonly type = '[FinalGrade] FetchFinalGrade';

    constructor(public payload: string) {}
}

export class FetchFinalGradeSuccess {
    static readonly type = '[FinalGrade] FetchFinalGradeSuccess';

    constructor(public payload: FinalGrade) {}
}

export class FetchFinalGradeFailure {
    static readonly type = '[FinalGrade] FetchFinalGradeFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class AddFinalGrades {
    static readonly type = '[FinalGrade] AddFinalGrades';

    constructor(public payload: FinalGrade[]) {}
}

export class UpdateFinalGrade {
    static readonly type = '[FinalGrade] UpdateFinalGrade';

    constructor(public payload: FinalGrade) {}
}

export class UpdateFinalGradeSuccess {
    static readonly type = '[FinalGrade] UpdateFinalGradeSuccess';

    constructor(public payload: FinalGrade) {}
}

export class UpdateFinalGradeFailure {
    static readonly type = '[FinalGrade] UpdateFinalGradeFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteFinalGrade {
    static readonly type = '[FinalGrade] DeleteFinalGrade';

    constructor(public payload: string) {}
}

export class DeleteFinalGradeSuccess {
    static readonly type = '[FinalGrade] DeleteFinalGradeSuccess';

    constructor(public payload: string) {}
}

export class DeleteFinalGradeFailure {
    static readonly type = '[FinalGrade] DeleteFinalGradeFailure';

    constructor(public payload: string) {}
}

export class SetFinalGrades {
    static readonly type = '[FinalGrade] SetFinalGrades';

    constructor(public payload: FinalGrade[]) {}
}

export class FetchFinalGrades {
    static readonly type = '[FinalGrade] FetchFinalGrades';
}

export class FetchFinalGradesSuccess {
    static readonly type = '[FinalGrade] FetchFinalGradesSuccess';
}

export class FetchFinalGradesFailure {
    static readonly type = '[FinalGrade] FetchFinalGradesFailure';
}

export class BulkUpdateFinalGrades {
    static readonly type = '[FinalGrade] BulkUpdateFinalGrades';

    constructor(public payload: FinalGradeCommand[]) {}
}

export class BulkUpdateFinalGradesSuccess {
    static readonly type = '[FinalGrade] BulkUpdateFinalGradesSuccess';

    constructor(public payload: FinalGrade[]) {}
}

export class BulkUpdateFinalGradesFailure {
    static readonly type = '[FinalGrade] BulkUpdateFinalGradesFailure';

    constructor(public payload: string) {}
}

export class BulkUpdateFinalGradesStatus {
    static readonly type = '[FinalGrade] BulkUpdateFinalGradesStatus';

    constructor(
        public payload: {
            entities: string[];
            status: string;
        }
    ) {}
}

export class BulkUpdateFinalGradesStatusSuccess {
    static readonly type = '[FinalGrade] BulkUpdateFinalGradesStatusSuccess';

    constructor(public payload: FinalGrade[]) {}
}

export class BulkUpdateFinalGradesStatusFailure {
    static readonly type = '[FinalGrade] BulkUpdateFinalGradesStatusFailure';

    constructor(public payload: string) {}
}

export class FetchFinalGradesForCurrentUser {
    static readonly type = '[FinalGrade] FetchFinalGradesForCurrentUser';
}

export class FetchFinalGradesForCurrentUserSuccess {
    static readonly type = '[FinalGrade] FetchFinalGradesForCurrentUserSuccess';

    constructor(public payload: FinalGradeExtended[]) {}
}

export class FetchFinalGradesForCurrentUserFailure {
    static readonly type = '[FinalGrade] FetchFinalGradesForCurrentUserFailure';

    constructor(public payload: string) {}
}

export class AssignFinalGradeCertificate {
    static readonly type = '[FinalGrade] AssignFinalGradeCertificate';

    constructor(public payload: FinalGrade) {}
}

export class AssignFinalGradeCertificateSuccess {
    static readonly type = '[FinalGrade] AssignFinalGradeCertificateSuccess';

    constructor(public payload: IFinalGradeCertificate) {}
}

export class AssignFinalGradeCertificateFailure {
    static readonly type = '[FinalGrade] AssignFinalGradeCertificateFailure';

    constructor(public payload: { response: HttpErrorResponse }) {}
}

export class BulkAssignFinalGradeCertificates {
    static readonly type = '[FinalGrade] BulkAssignFinalGradeCertificates';

    constructor(public payload: string) {}
}

export class BulkAssignFinalGradeCertificatesSuccess {
    static readonly type = '[FinalGrade] BulkAssignFinalGradeCertificatesSuccess';

    constructor(public payload: string) {}
}

export class BulkAssignFinalGradeCertificatesFailure {
    static readonly type = '[FinalGrade] BulkAssignFinalGradeCertificatesFailure';

    constructor(public payload: { response: HttpErrorResponse }) {}
}

export class UnassignFinalGradeCertificate {
    static readonly type = '[FinalGrade] UnassignFinalGradeCertificate';

    constructor(public payload: FinalGrade) {}
}

export class UnassignFinalGradeCertificateSuccess {
    static readonly type = '[FinalGrade] UnassignFinalGradeCertificateSuccess';
}

export class UnassignFinalGradeCertificateFailure {
    static readonly type = '[FinalGrade] UnassignFinalGradeCertificateFailure';

    constructor(public payload: { response: HttpErrorResponse }) {}
}

export class BulkUnassignFinalGradeCertificates {
    static readonly type = '[FinalGrade] BulkUnassignFinalGradeCertificates';

    constructor(public payload: string) {}
}

export class BulkUnassignFinalGradeCertificatesSuccess {
    static readonly type = '[FinalGrade] BulkUnassignFinalGradeCertificatesSuccess';

    constructor(public payload: string) {}
}

export class BulkUnassignFinalGradeCertificatesFailure {
    static readonly type = '[FinalGrade] BulkUnassignFinalGradeCertificatesFailure';

    constructor(public payload: { response: HttpErrorResponse }) {}
}

export class FetchGradesForParticipant {
    static readonly type = '[FinalGrade] FetchGradesForParticipant';

    constructor(
        public payload: {
            moduleId: string;
        }
    ) {}
}

export class FetchGradesForParticipantSuccess {
    static readonly type = '[FinalGrade] FetchGradesForParticipantSuccess';
}

export class FetchGradesForParticipantFailure {
    static readonly type = '[FinalGrade] FetchGradesForParticipantFailure';
}
